import { render, staticRenderFns } from "./particulars.vue?vue&type=template&id=0ba35e72&scoped=true&"
import script from "./particulars.vue?vue&type=script&lang=js&"
export * from "./particulars.vue?vue&type=script&lang=js&"
import style0 from "./particulars.vue?vue&type=style&index=0&id=0ba35e72&scoped=true&lang=css&"
import style1 from "./particulars.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba35e72",
  null
  
)

export default component.exports